import { InjectionToken } from "@angular/core";

/**
 * DEV-966 — quem sabe ABRIR a escolha de atribuição é o app (a janela precisa dos DTOs de
 * atribuição, que vivem no platform). O shared-core só conhece este contrato: o menu de perfil
 * pede a ativação e o app decide o que mostrar. Desligar não passa por aqui — é imediato e vive em
 * `OfflineModeService.disable()`.
 *
 * Sem provider (ex.: admin), o item "Modo Offline" não aparece no menu de perfil.
 */
export interface OfflineModeActivator {
  requestEnable(): void;
}

export const OFFLINE_MODE_ACTIVATOR = new InjectionToken<OfflineModeActivator>(
  "OFFLINE_MODE_ACTIVATOR"
);
